import { useTranslation } from 'react-i18next';

import { TrackedNavLink } from '../../TrackedNavLink/TrackedNavLink';

import type { FunctionComponent, SVGProps } from 'react';

export interface MenuItemProps {
  id: string;
  labelKey: string;
  Icon: FunctionComponent<SVGProps<SVGSVGElement>>;
  to?: string;
  href?: string;
  target?: string;
  rel?: string;
  className?: string;
  layout?: 'wide' | 'narrow';
  onClick?: () => void;
}

const MenuItem = ({ id, labelKey, Icon, to, onClick, className, layout = 'wide', ...props }: MenuItemProps) => {
  const { t } = useTranslation('navigation');

  return (
    <li>
      <TrackedNavLink
        id={id}
        to={to}
        trackingId={id}
        icon={<Icon width={layout === 'wide' ? 24 : 28} height={layout === 'wide' ? 24 : 28} />}
        layout={layout}
        title={t(labelKey)}
        onClick={onClick}
        className={className}
        {...(props.href ? { href: props.href, target: props.target, rel: props.rel } : { type: 'button' })}
      />
    </li>
  );
};

export { MenuItem };
